import { ref } from 'vue';
import { Ref } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

/**
 *
 * @returns {{maxDesktopFilters: Ref<number>,maxTabletFilters: Ref<number> }}
 */
export default function useMaxFiltersNumber() {
  const maxDesktopFilters = ref(7);
  const maxTabletFilters = ref(7);

  return {
    maxDesktopFilters,
    maxTabletFilters,
  };
}
